angular.module('impactx.controlstructure').controller('LOCCtrl', [
    '$scope',
    '$controller',
    'ToolbarService',
    LOCCtrl
]);

function LOCCtrl($scope, $controller, ToolbarService) {
    var self = this;
    angular.extend(self, $controller('ControlStructureCtrl', {$scope: $scope}));

    $scope.endPointView = "/control/loc/view";
    $scope.endPointSave = "/control/loc/save";
    $scope.endPointDelete = "/control/loc/delete";

    $scope.getPageData().then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: $scope.savePageData,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: $scope.delete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.loc.readOnly;
    }

    function canDelete() {
        return $scope.id > 0 && !$scope.data.loc.readOnly && !$scope.data.loc.deprecated;
    }
}